export default __webpack_public_path__ + "static/media/amazon-placeholder.4542f436.png";